/**
 * LegalPage — standalone public route backing the /privacy and /terms
 * deep-links. Renders the Legal Center (LegalModal) opened directly to
 * the requested doc over a branded backdrop, so a bare URL — an app-store
 * listing, an email footer, or "worldby.me/privacy" typed by hand — lands
 * on the actual policy text (the modal renders the full doc body into the
 * DOM when open).
 *
 * Auth-agnostic by design: mounted at the App() top level, before the auth
 * providers, the same tier as /reset-password and /account/delete — legal
 * docs must be readable by logged-out visitors and app-store reviewers.
 *
 * Closing the modal (X, Escape, or scrim) returns to the site root.
 */
import { ChromeTokens } from "../chrome/tokens";
import { LegalModal } from "./LegalModal";
import type { LegalDocId } from "./docs";

export function LegalPage({ doc }: { doc: LegalDocId }): JSX.Element {
  const goHome = () => window.location.assign("/");
  return (
    <div
      style={{
        minHeight: "100vh",
        background: `linear-gradient(180deg, ${ChromeTokens.color.sky}, ${ChromeTokens.color.base})`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: ChromeTokens.spacing.xl,
      }}
    >
      {/* Backdrop wordmark so the page reads as intentional behind the
          modal scrim; the modal carries the actual content. */}
      <img
        src="/logo/wordmark-color-medium.png"
        alt="world by me"
        style={{ height: 44, width: "auto", display: "block", opacity: 0.9 }}
      />
      <LegalModal open doc={doc} onClose={goHome} seal />
    </div>
  );
}
